// Arabic Work index — mirrors the English WorkIndex. Uses the same
// WORK_THUMBS assets (mapped by thumbnailId).
import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { ArPageHero, ArBlock, ArContactCTA } from "@/pages/ar/_ArShared";
import { WORK_AR, WORK_INTRO_AR } from "@/data/work-ar";
import { cn } from "@/lib/utils";

const WORK_THUMBS = {
  "cs-delivery-hero": { webp: "/assets/cs-delivery-hero.webp", fallback: "/assets/cs-delivery-hero.jpg", alt: "سائق Twasal Awasal يسلّم طردًا لعميل أمام شاحنة توصيل حمراء." },
  "cs-wms": { webp: "/assets/cs-wms.webp", fallback: "/assets/cs-wms.jpg", alt: "داخل مستودع عند الغروب مع رافعات شوكية وعمّال بسترات عاكسة." },
  "cs-erp": { webp: "/assets/cs-erp.webp", fallback: "/assets/cs-erp.jpg", alt: "غرفة تحكم لوجستية تطل على ساحة شاحنات وحاويات مع لوحات مراقبة." },
  "cs-showroom": { webp: "/assets/cs-showroom.webp", fallback: "/assets/cs-showroom.jpg", alt: "معرض سيارات في مسقط بصفوف من السيارات والعملاء والموظفين." },
  "cs-marketplace": { webp: "/assets/cs-marketplace.webp", fallback: "/assets/cs-marketplace.jpg", alt: "امرأة تتسوق على حاسوب محمول عبر سوق إلكتروني." },
};

const STATUS_STYLES = {
  live: "bg-wafa-primary text-white",
  delivered: "bg-wafa-deep/10 text-wafa-deep",
  launching: "bg-wafa-sunshine text-wafa-deep",
  building: "bg-wafa-sunshine text-wafa-deep",
};
const STATUS_LABELS = { live: "مباشر", delivered: "تم التسليم", launching: "قريبًا", building: "قيد التطوير" };

function WorkThumb({ id }) {
  const t = WORK_THUMBS[id];
  if (!t) return null;
  return (
    <div className="overflow-hidden rounded-md bg-wafa-cream/40">
      <picture>
        <source type="image/webp" srcSet={t.webp} />
        <img
          src={t.fallback}
          alt={t.alt}
          width="1200"
          height="800"
          loading="lazy"
          decoding="async"
          className="block h-auto w-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
        />
      </picture>
    </div>
  );
}

export default function WorkIndexAr() {
  const list = Object.values(WORK_AR);
  return (
    <div data-testid="work-index-ar">
      <Seo title="الأعمال" description="أنظمة لنا تعمل الآن أو على وشك ذلك. موثّقة بشكل صحيح." />
      <ArPageHero
        eyebrow="الأعمال"
        h1="أنظمة لنا تعمل الآن فعليًا"
        sub={WORK_INTRO_AR}
        breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "الأعمال" }]}
      />

      <ArBlock tint="white">
        <div className="grid gap-6 md:grid-cols-2">
          {list.map((cs) => (
            <Link
              key={cs.slug}
              to={`/ar/work/${cs.slug}`}
              data-testid={`work-card-ar-${cs.slug}`}
              className="group flex flex-col rounded-lg border border-wafa-deep/10 bg-white p-4 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25 hover:shadow-[0_18px_40px_-20px_rgba(14,79,58,0.25)]"
            >
              <WorkThumb id={cs.thumbnailId} />
              <div className="p-3">
                <span className={cn("inline-flex rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider", STATUS_STYLES[cs.statusKind] || "bg-wafa-cream text-wafa-deep")}>
                  {STATUS_LABELS[cs.statusKind] || cs.status}
                </span>
                <div className="mt-3 font-heading text-xl font-semibold text-wafa-deep group-hover:text-wafa-primary">
                  {cs.h1}
                </div>
                <p className="mt-2 text-sm text-wafa-ink/70 line-clamp-3">{cs.intro}</p>
                <div className="mt-4 text-xs uppercase tracking-wider text-wafa-ink/60">{cs.status}</div>
              </div>
            </Link>
          ))}
        </div>
      </ArBlock>

      <ArContactCTA heading="تريدون أن نبني التالي؟" />
    </div>
  );
}
